// keep track of where they are used
// so later on when we change path, changing in one place is enough.

export const browserRoutes = {
    home: "",
    myLearning: "my-learning",
    myTeam: "my-team",
    profile: "profile",
    collection: "collection",
};

export const hashRoutes = {
    contentItem: "contentitem",
};

export const defaultHashRoute = "/_";
